import { Edit, Loader2, RefreshCw, X ,Calendar , Package  } from 'lucide-react'
import React, { useState, useEffect } from 'react'
import HandleEntry from '../Common/HandleEntry';
import HandleExit from '../Common/HandleExit';
import HandlePayment from '../Common/HandlePayment';
import leftarrow from "../../assets/left-arrow 1.svg";
import FormatTime from '../Common/FormatTime';
import FormatDate from '../Common/FormatDate.jsx';
import profile from "../../assets/profile.png"
import { usePayment } from "../../context/PaymentContext.jsx";
import ScheduledPayments from "../../assets/schedule.png";
import axios from 'axios';
import ConfirmModal, {
  RegenerateIcon,
  ApproveIcon,
  RejectIcon,
} from './ConfirmModal.jsx';
import calenderlogo from "../../assets/calenderlogo.svg"
import { useSuperAdmin } from '../../context/SuperAdminContext.jsx';

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Display order + labels for payout-mode groups. If the API sends a mode
// not listed here, it will still render, just appended at the end.
const PAYOUT_MODE_ORDER = ["Daily_Payout", "Scheduled_Payout", "Upcoming_Scheduled_Payout"];
const PAYOUT_MODE_LABEL = {
  Daily_Payout: "Payout Going Today ",
  Scheduled_Payout: "Scheduled Payout Transactions for Today",
  Upcoming_Scheduled_Payout: "Payout Scheduled For Future",
};

const Payoutfile = () => {
  const { listPayoutFile, regeneratePayoutFile, submitPayoutFile, editWorkerListingData} = usePayment();
  const {token}= useSuperAdmin();

  const [loading, setLoading]                         = useState(false);
  const [selectedRecord, setSelectedRecord]           = useState([]);
  const [showEntryModal, setShowEntryModal]           = useState(false);
  const [showExitModal, setShowExitModal]             = useState(false);
  const [paymentEditModal, setPaymentEditModal]       = useState({ isOpen: false, record: null });
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [selectedAttendanceId, setSelectedAttendanceId]   = useState(null);
  const [retryingPayments, setRetryingPayments]       = useState({});
  const [isUTVMember,setIsUTVMember]                                 = useState(false);
  const [showSuccessModal, setShowSuccessModal]       = useState(false);
  const [showApprovalSuccessModal, setShowApprovalSuccessModal] = useState(false);
  const [showapprovalrejectmodal, setshowapprovalrejectmodal]   = useState(false);
  const [filestatus, setfilestatus]                   = useState("");
  const [editable, seteditable]                       = useState(false);
  const [response, setresponse]                       = useState(null);
  const [selectedStatus, setSelectedStatus]           = useState("");
  const [fileName, setfileName] = useState("")
  const [showentrymarkdays, setshowentrymarkdays] = useState("")


  // ── Remarks state ─────────────────────────────────────────────────────────
  const [showRemarksModal, setShowRemarksModal] = useState(false);
  const [remarks, setRemarks]                   = useState("");

  // ── Confirmation modal state ──────────────────────────────────────────────
  const [activeConfirm, setActiveConfirm] = useState(null);
  const openConfirm  = (key) => setActiveConfirm(key);
  const closeConfirm = ()    => setActiveConfirm(null);

  // ── Edited rows ───────────────────────────────────────────────────────────
  const [editedRowIds, setEditedRowIds] = useState(new Set());

  // ── Table / summary ───────────────────────────────────────────────────────
  // tableData is now an array of payout-mode groups:
  // [{ payoutMode, label, totalWorkers, totalPayoutToday, paidTodayCount, totalCount, departments: [...] }]
  const [tableData, setTableData]   = useState([]);
  const [summaryData, setSummaryData] = useState({
    uniqueWorkers: 0, totalShifts: 0, totalGross: 0,
    totalDeductions: 0, total_additional_Deductions: 0,
    totalPromotions: 0, totalPayout: 0,
  });


  const [accessoryTooltip, setAccessoryTooltip] = useState({
  visible: false,
  position: { x: 0, y: 0 },
  content: null,
  recordId: null,
});

const showAccessoryTooltip = (e, record) => {
  // Only build tooltip content if accessories array actually has items
  if (!record.accessories || record.accessories.length === 0) return;

  const items = [];

  record.accessories.forEach((acc) => {
    items.push({
      accessoryId: acc.accessoryId,
      name: acc.name,
      logo: acc.logo,
      deduction: Number(acc.deduction || 0),
    });
  });

  const totalDeduction = items.reduce((sum, a) => sum + Number(a.deduction || 0), 0);
  const rect = e.currentTarget.getBoundingClientRect();

  const tooltipWidth = 220;
  const margin = 8;

  let x = rect.left + rect.width / 2;
  const minX = tooltipWidth / 2 + margin;
  const maxX = window.innerWidth - tooltipWidth / 2 - margin;
  x = Math.min(Math.max(x, minX), maxX);

  setAccessoryTooltip({
    visible: true,
    position: { x, y: rect.top },
    content: { accessories: items, totalDeduction },
    recordId: record.id,
  });
};

const hideAccessoryTooltip = () => {
  setAccessoryTooltip({ visible: false, position: { x: 0, y: 0 }, content: null, recordId: null });
};

  // ── Collapse (department-level, unchanged) ───────────────────────────────
const [collapsedDepts, setCollapsedDepts] = useState({});
const deptKey = (payoutMode, deptId) => `${payoutMode}::${deptId}`;
const isDeptCollapsed = (payoutMode, deptId) => collapsedDepts[deptKey(payoutMode, deptId)] !== false;
const toggleDept = (payoutMode, deptId) =>
  setCollapsedDepts(prev => ({
    ...prev,
    [deptKey(payoutMode, deptId)]: isDeptCollapsed(payoutMode, deptId) ? false : true,
  }));
  // ── Collapse (payout-mode level: Daily / Weekly / Monthly) ───────────────
  // Daily starts expanded, Weekly/Monthly start collapsed (matches design).
const [collapsedModes, setCollapsedModes] = useState({
  Daily_Payout: false,              // starts open
  Scheduled_Payout: true,           // starts closed
  Upcoming_Scheduled_Payout: true,  // starts closed
});
  const toggleMode = (mode) =>
    setCollapsedModes(prev => ({ ...prev, [mode]: !prev[mode] }));

  // ── Step 1: Parse URL once ────────────────────────────────────────────────
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const role   = params.get("role");

    setSelectedStatus(role ?? "");
  }, []);

  // ── Step 2: Fetch user from verify-token ──────────────────────────────────
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const res   = await axios.get(`${BASE_URL}/lenskart/verify-token`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.data?.success && res.data?.user) {
          localStorage.setItem("userData", JSON.stringify(res.data.user));
          setresponse(res.data);
          setIsUTVMember(res.data.user.UTVMember)
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchUserData();
  }, [BASE_URL]);

  // ── Step 3: Fetch payout data only when BOTH response + selectedStatus ready
  useEffect(() => {
    if (!response?.user || !selectedStatus) return;
    const params       = new URLSearchParams(window.location.search);
    const payoutfilesid = params.get("id");
    const companyId=params.get("companyId");
    if (!payoutfilesid) return;
    fetchPayoutData(payoutfilesid, selectedStatus, response.user.role,companyId);
  }, [response, selectedStatus]);

  // ── Helper: enrich a single department's records (unchanged logic) ───────
  const enrichDepartment = (dept) => {
    const totalPayableAmt = dept.records.reduce(
      (sum, r) => sum + parseFloat(r.net_amount ?? 0), 0
    );
    const uniquePhones = new Set(dept.records.map((r) => r.workerPhone));
    return { ...dept, totalPayableAmt, totalWorkers: uniquePhones.size };
  };

  // ── Helper: build a single payout-mode group from a departmentWiseData array
const buildGroup = (payoutMode, departmentWiseData, extra = {}) => {
  const merged = mergeDepartmentsById(departmentWiseData);
  const departments = merged.map(enrichDepartment);
  const totalWorkers = new Set(
    departments.flatMap((dept) => dept.records.map((r) => r.workerPhone))
  ).size;
  const totalPayoutToday = departments.reduce(
    (sum, dept) => sum + dept.records.reduce((s, r) => s + parseFloat(r.net_amount ?? 0), 0),
    0
  );
  return {
    payoutMode,
    label: PAYOUT_MODE_LABEL[payoutMode] ?? payoutMode,
    totalWorkers,
    totalPayoutToday,
    paidTodayCount: undefined,
    totalCount: undefined,
    departments,
    ...extra,
  };
};

const buildModeGroups = (data) => {
  let groups;

  if (Array.isArray(data.payoutModeWiseData)) {
    groups = data.payoutModeWiseData.map((group) => ({
      payoutMode: group.payoutMode,
      label: PAYOUT_MODE_LABEL[group.payoutMode] ?? group.payoutMode,
      totalWorkers: group.totalWorkers ?? 0,
      totalPayoutToday: group.totalPayoutToday ?? 0,
      paidTodayCount: group.paidTodayCount,
      totalCount: group.totalCount,
      departments: (group.departmentWiseData ?? []).map(enrichDepartment),
    }));
  } else {

    const dailyDepts = (data.departmentWiseData || []).map((dept) => ({
      ...dept,
      records: dept.records.map((r) => ({
        ...r,
        isScheduled: r.isScheduledPayment === true,
      })),
    }));

    // UpcomingPayments are always future-dated, so they get the yellow
    // "upcoming" badge regardless of isScheduledPayment (it's true here too,
    // but the date puts them in a separate bucket from Daily_Payout).
    const upcomingDepts = (data.UpcomingPayments || []).map((dept) => ({
      ...dept,
      records: dept.records.map((r) => ({ ...r, isUpcoming: true })),
    }));

    groups = [
      buildGroup("Daily_Payout", dailyDepts),
      buildGroup("Upcoming_Scheduled_Payout", upcomingDepts),
    ];
  }

  groups.sort((a, b) => {
    const ai = PAYOUT_MODE_ORDER.indexOf(a.payoutMode);
    const bi = PAYOUT_MODE_ORDER.indexOf(b.payoutMode);
    return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
  });

  return groups;
};

  // ── Fetch payout data ─────────────────────────────────────────────────────
const fetchPayoutData = async (payoutfilesid, role, userRole, companyId, resetEdits = true) => {
    try {
      setLoading(true);
      const data = await listPayoutFile({ payoutfiles_id: payoutfilesid,payout_type:"daily_payout",companyId });
      if (data?.success) {
        const modeGroups = buildModeGroups(data);
        setTableData(modeGroups);

        const status          = data.payoutFileStatus;
        setfilestatus(status);
        setfileName(data.fileName);

        //  Compute from params — not from stale state
        const _isadmin         = userRole === "Admin";
        const _hasPayoutGen    = ((role === "Payout Generator")&&response.user.featureAccess.includes("Payout Generator"));
        const _hasPayoutApproval = ((role === "Payout Approver")&&response.user.featureAccess.includes("Payout Approver"));

        console.log("editable check →", { _isadmin, _hasPayoutGen, _hasPayoutApproval, status });

        if (_isadmin && _hasPayoutGen && _hasPayoutApproval) {
          seteditable(["file_updated","file_generated","submitted_to_admin",
            "file_to_be_generated_by_approver","file_to_be_generated",
            "file_updated_by_admin","rejected_by_admin","rejected_by_accounts"].includes(status));
        } else if (_isadmin && _hasPayoutGen) {
          seteditable(["file_updated","file_generated","file_to_be_generated",
            "rejected_by_admin"].includes(status));
        } else if (_isadmin && _hasPayoutApproval) {
          seteditable(["submitted_to_admin","file_to_be_generated_by_approver",
            "file_to_be_generated","file_updated_by_admin",
            "rejected_by_accounts"].includes(status));
        } else {
          seteditable(false);
        }

        if (resetEdits) {
          setEditedRowIds(new Set());
        }
        setSummaryData({
          uniqueWorkers:               data.summary?.totalWorkers              ?? 0,
          totalShifts:                 data.summary?.totalShifts               ?? 0,
          totalGross:                  data.summary?.totalGross                ?? 0,
          totalDeductions:             data.summary?.totalDeductions           ?? 0,
          total_additional_Deductions: data.summary?.totalAdditionalDeductions ?? 0,
          totalPromotions:             data.summary?.totalBonus                ?? 0,
          totalPayout:                 data.summary?.totalPayout               ?? 0,
        });
      }
    } catch (error) {
      console.error("Error fetching payout data:", error);
    } finally {
      setLoading(false);
    }
  };

  // ── Derived flags (for rendering)
  const isadmin        = response?.user?.role === "Admin";
  const isSuperadmin   = response?.user?.role === "super_admin";
  const hasPayoutGen   = selectedStatus === "Payout Generator";
  const hasPayoutApproval = selectedStatus === "Payout Approver";

  // ── Action handlers 
  const fetchlistingdata = async () => {
    const params        = new URLSearchParams(window.location.search);
    const payoutfilesid = params.get("id");
    if (!payoutfilesid) return;
    try {
      setLoading(true);
      const data = await regeneratePayoutFile({
        payoutfiles_id: payoutfilesid,
        lastFileStatus: filestatus,
      });
      if (data?.success) setShowSuccessModal(true);
    } catch (error) {
      console.error("Error regenerating payout file:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSendForadminApproval = async () => {
    const params        = new URLSearchParams(window.location.search);
    const payoutfilesid = params.get("id");
    if (!payoutfilesid) return;
    try {
      setLoading(true);
      const data = await submitPayoutFile({
        payoutfiles_id: payoutfilesid,
        file_status: "submitted_to_admin",
      });
      if (data?.success) setShowApprovalSuccessModal(true);
    } catch (error) {
      console.error("Error submitting payout file:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSendForaccountApproval = async (accepted, rejectionRemarks = "") => {
    const params        = new URLSearchParams(window.location.search);
    const payoutfilesid = params.get("id");
    if (!payoutfilesid) return;
    try {
      setLoading(true);
      const data = await submitPayoutFile({
        payoutfiles_id: payoutfilesid,
        file_status: accepted ? "submitted_to_account" : "rejected_by_admin",
        ...(accepted === false && { rejection_reason_by_admin: rejectionRemarks }),
      });
      if (data?.success) {
        accepted ? setShowApprovalSuccessModal(true) : setshowapprovalrejectmodal(true);
      }
    } catch (error) {
      console.error("Error submitting payout file:", error);
    } finally {
      setLoading(false);
    }
  };

  // Merge department blocks that share the same departmentId, combining their records.
const mergeDepartmentsById = (deptArray) => {
  const map = new Map();
  (deptArray ?? []).forEach((dept) => {
    if (!dept) return;
    const existing = map.get(dept.departmentId);
    if (existing) {
      existing.records = [...existing.records, ...dept.records];
    } else {
      map.set(dept.departmentId, { ...dept, records: [...dept.records] });
    }
  });
  return Array.from(map.values());
};

  const handleRemarksSubmit = () => {
    setShowRemarksModal(false);
    handleSendForaccountApproval(false, remarks);
    setRemarks("");
  };

  // ── Row helpers ───────────────────────────────────────────────────────────
  const toWorkerPayload = (record) => ({
    ...record,
    attendanceId: record.shift_id,
    userId:       record.user_id,
  });

  const updateRowInTable = (shiftId, updatedFields) => {
    setTableData((prevModeGroups) =>
      prevModeGroups.map((modeGroup) => ({
        ...modeGroup,
        departments: modeGroup.departments.map((dept) => ({
          ...dept,
          records: dept.records.map((rec) =>
            rec.shift_id === shiftId
              ? {
                  ...rec, ...updatedFields,
                  entry_date:     updatedFields.entry_date     ?? rec.entry_date,
                  exit_date:      updatedFields.exit_date      ?? rec.exit_date,
                  net_amount:     updatedFields.net_amount     ?? rec.net_amount,
                  onHold:         updatedFields.onHold         ?? rec.onHold,
                  departmentName: updatedFields.department     ?? rec.department,
                }
              : rec
          ),
        })),
      }))
    );
    setEditedRowIds((prev) => new Set(prev).add(shiftId));
  };

  const handleRowClick          = (userId) => window.open(`/lkart/superadmin/attendance-history/${userId}`, "_blank");

  const handleEntryClick = async (record, e) => {
    e.stopPropagation();
    const data = await editWorkerListingData(toWorkerPayload(record));
    if (data?.success) { setSelectedRecord({ ...data, _shiftId: record.shift_id }); setShowEntryModal(true);
  setshowentrymarkdays(data?.EntryMarkedForPreviousDays || "7")
  }
  };

  const handleExitClick = async (record, e) => {
    e.stopPropagation();
    const data = await editWorkerListingData(toWorkerPayload(record));
    if (data?.success) { setSelectedRecord({ ...data, _shiftId: record.shift_id }); setShowExitModal(true); }
  };

  const handlePaymentEditClick = async (record, e) => {
    e.stopPropagation();
    const data = await editWorkerListingData(toWorkerPayload(record));
    if (data?.success) setPaymentEditModal({ isOpen: true, record: { ...data, _shiftId: record.shift_id } });
  };

  const hasEdits = editedRowIds.size > 0;

  // hasAnyRecords: whether any mode group has any department with records
  const hasAnyRecords = tableData.some((mg) => mg.departments.length > 0);


const refetchPayoutData = () => {
    const params = new URLSearchParams(window.location.search);
    const payoutfilesid = params.get("id");
    const companyId = params.get("companyId");
    if (!payoutfilesid || !response?.user || !selectedStatus) return;
    fetchPayoutData(payoutfilesid, selectedStatus, response.user.role, companyId, false);
  };
const handleChildDataUpdate = (shiftId) => {
  setEditedRowIds((prev) => {
    const next = new Set(prev);
    next.add("__manual_edit__");
    if (shiftId) next.add(shiftId);
    return next;
  });
  refetchPayoutData();
};

  return (
    <>
    {isUTVMember &&
      <div className="p-7 h-screen overflow-hidden flex flex-col bg-gray-50">

        <h1 className="font-bold text-xl mb-2 text-center pt-10 pb-2 flex-shrink-0">{fileName}</h1>

        {/* ── Summary ── */}
        <div className="mb-4 bg-white rounded-lg shadow-sm p-3 flex-shrink-0">
          <h2 className="font-bold text-s text-black mb-2">Payout Summary</h2>
          <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1">
            {[
              { color: 'bg-green-500',  label: 'Total Unique Workers :', value: summaryData.uniqueWorkers,               prefix: ''  },
              { color: 'bg-pink-500',   label: 'Total Shifts :',          value: summaryData.totalShifts,                prefix: ''  },
              { color: 'bg-orange-400', label: 'Total Gross Amount :',    value: summaryData.totalGross,                 prefix: '₹' },
              { color: 'bg-red-500',    label: 'Total Deductions :',      value: summaryData.totalDeductions,            prefix: '₹' },
              { color: 'bg-red-500',    label: 'Total Additional Deductions :', value: summaryData.total_additional_Deductions, prefix: '₹' },
              { color: 'bg-green-500',  label: 'Total Promotions :',      value: summaryData.totalPromotions,            prefix: '₹' },
              { color: 'bg-teal-500',   label: 'Total Payouts :',         value: summaryData.totalPayout,                prefix: '₹' },
            ].map(({ color, label, value, prefix }) => (
              <div key={label} className="flex items-center gap-1">
                <span className={`w-1.5 h-1.5 rounded-full ${color} flex-shrink-0`} />
                <span className="text-gray-600 text-xs">{label}</span>
                <span className="font-semibold text-gray-900 text-xs">{prefix}{value}</span>
              </div>
            ))}
          </div>
        </div>

        {/* ── Icon Legend ── */}
<div className="mb-3 bg-white rounded-lg shadow-sm px-3 py-1.5 flex-shrink-0 flex flex-wrap items-center gap-4 text-[11px] text-gray-600">

  {/* Normal */}
  <div className="flex items-center gap-1">
    <img
      src={profile}
      alt="Normal"
      className="w-[23px] h-[23px] rounded-full object-cover border border-gray-300 flex-shrink-0"
    />
    <span>Daily Payment</span>
  </div>

  {/* Scheduled (green) */}
  <div className="flex items-center gap-1">
    <div style={{ position: 'relative', width: 23, height: 23, flexShrink: 0 }}>
      <img
        src={profile}
        alt="Scheduled"
        style={{ width: 23, height: 23, borderRadius: '50%', objectFit: 'cover', border: '2px solid #22c55e' }}
      />
      <div
        style={{
          position: "absolute",
          bottom: -8,
          right: -8,
          width: 18,
          height: 18,
          borderRadius: "50%",
          background: "#fff",
          border: "1.5px solid #fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxSizing: "border-box",
        }}
      >
        <img
          src={calenderlogo}
          alt="Calendar"
          style={{
            width: 16,
            height: 16,
            objectFit: "contain",
            filter:
              "invert(48%) sepia(79%) saturate(500%) hue-rotate(100deg) brightness(50%)",
          }}
        />
      </div>
    </div>
    <span>Scheduled Payment (To Be Processed)</span>
  </div>

  {/* Upcoming (yellow) */}
  <div className="flex items-center gap-1">
    <div style={{ position: "relative", width: 23, height: 23, flexShrink: 0 }}>
      <img
        src={profile}
        alt="Upcoming"
        style={{
          width: 23,
          height: 23,
          borderRadius: "50%",
          objectFit: "cover",
          border: "2px solid #eab308",
        }}
      />

      <div
        style={{
          position: "absolute",
          bottom: -8,
          right: -8,
          width: 18,
          height: 18,
          borderRadius: "50%",
          background: "#fff",
          border: "1.5px solid #fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxSizing: "border-box",
        }}
      >
        <img
          src={calenderlogo}
          alt="Calendar"
          style={{
            width: 16,
            height: 16,
            objectFit: "contain",
            filter:
              "invert(76%) sepia(90%) saturate(1000%) hue-rotate(355deg) brightness(50%)",
          }}
        />
      </div>
    </div>

    <span>Payout scheduled for a Later Date</span>
  </div>

  {/* Old payment entry (red + arrow) */}
  <div className="flex items-center gap-1">
    <div
      style={{
        position: "relative",
        width: 23,
        height: 23,
        flexShrink: 0,
      }}
    >
      <img
        src={profile}
        alt="Old Entry"
        style={{
          width: 23,
          height: 23,
          borderRadius: "50%",
          objectFit: "cover",
          border: "2px solid red",
        }}
      />

      <div
        style={{
          position: "absolute",
          bottom: -8,
          right: -8,
          width: 18,
          height: 18,
          borderRadius: "50%",
          background: "#fff",
          border: "1.5px solid #fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxSizing: "border-box",
        }}
      >
        <img
          src={leftarrow}
          alt="Old Entry"
          style={{
            width: 16,
            height: 16,
            objectFit: "contain",
          }}
        />
      </div>
    </div>

    <span>Released Payment (Blocked Earlier)</span>
  </div>
</div>

        {/* ── Table + Buttons ── */}
        <div className="flex-1 flex flex-col min-h-0">
          {loading ? (
            <div className="flex items-center justify-center flex-1">
              <div className="flex flex-col items-center gap-2">
                <Loader2 className="h-8 w-8 animate-spin text-indigo-600" />
                <p className="text-gray-500 text-sm">Loading payout data...</p>
              </div>
            </div>
          ) : (
            <div className="max-h-[78vh] overflow-y-auto overflow-x-auto relative">
              <table className="w-full text-xs border-collapse">
                <thead className="sticky top-0 bg-white shadow-md z-[50]">
                  <tr className="bg-gray-100">
                    <th className="p-1.5 text-left text-xs">Name <br />(Worker Code)</th>
                    <th className="p-1.5 text-center text-xs">Entry Time</th>
                    <th className="p-1.5 text-center text-xs">Exit Time</th>
                    <th className="p-1.5 text-center text-xs">Working Hrs</th>
                    <th className="p-1.5 text-center text-xs">Hourly Rate</th>
                    <th className="p-1.5 text-center text-xs">Amount</th>
                    <th className="p-1.5 text-center text-xs text-blue-500">Food</th>
                    <th className="p-1.5 text-center text-xs text-blue-500">Bus Entry</th>
                    <th className="p-1.5 text-center text-xs text-blue-500">Bus Exit</th>
                    <th className="p-1.5 text-center text-xs text-blue-500">Essentials</th>
                    <th className="p-1.5 text-center text-xs text-blue-500">Additional <br /> Deduction</th>
                    <th className="p-1.5 text-center text-xs text-blue-500">Bonus/Refund <br />Amount</th>
                    <th className="p-1.5 text-center text-xs">Payout</th>
                  </tr>
                </thead>
                <tbody>
                  {!hasAnyRecords ? (
                    <tr>
                      <td colSpan={13} className="text-center p-8 text-gray-400 text-sm">No payout data found</td>
                    </tr>
                  ) : (
                    tableData.map((modeGroup) => (
                      <React.Fragment key={modeGroup.payoutMode}>
                        {/* ── Payout-mode row (Daily / Weekly / Monthly) ── */}
{/* ── Payout-mode row (Daily / Weekly / Monthly) ── */}
<tr
  className="bg-gray-100 h-10 border-t border-b border-slate-300 cursor-pointer select-none"
  onClick={() => toggleMode(modeGroup.payoutMode)}
>
  <td className="p-1.5 font-bold text-gray-800 text-xs whitespace-nowrap">
    <div className="flex items-center gap-1.5 font-bold">
      <svg
        className="h-3 w-3 text-slate-600 transition-transform duration-200 flex-shrink-0"
        style={{ transform: collapsedModes[modeGroup.payoutMode] ? 'rotate(-90deg)' : 'rotate(0deg)' }}
        fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}
      >
        <polyline points="6 9 12 15 18 9" />
      </svg>

      {modeGroup.label}

    </div>
  </td>
  <td colSpan={6} />
  <td colSpan={6} className="p-1.5 text-right whitespace-nowrap">
    <span className="text-xs font-semibold text-gray-700 mr-5">
      Total Payable Amt : ₹{Number(modeGroup.totalPayoutToday).toLocaleString()}
    </span>
    <span className="text-xs font-semibold text-gray-700">
      Total Workers : {modeGroup.totalWorkers}
    </span>
  </td>
</tr>

                        {!collapsedModes[modeGroup.payoutMode] && (
                          modeGroup.departments.length === 0 ? (
                            <tr>
                              <td colSpan={13} className="text-center p-4 text-gray-400 text-xs">No {modeGroup.label.toLowerCase()} data</td>
                            </tr>
                          ) : (
                            modeGroup.departments.map((dept) => (
                              <React.Fragment key={dept.departmentId}>
                                {/* Department row */}
                                <tr
  className="bg-blue-100 border-t border-b border-blue-200 cursor-pointer select-none"
  onClick={() => toggleDept(modeGroup.payoutMode, dept.departmentId)}
>
                                  <td className="p-1.5 font-bold text-gray-800 text-xs whitespace-nowrap">
                                    <div className="flex items-center gap-1.5">
                                      <svg
                                        className="h-3 w-3 text-blue-600 transition-transform duration-200 flex-shrink-0"
                                        style={{ transform: isDeptCollapsed(modeGroup.payoutMode, dept.departmentId) ? 'rotate(-90deg)' : 'rotate(0deg)' }}
                                        fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}
                                      >
                                        <polyline points="6 9 12 15 18 9" />
                                      </svg>
                                      Department : {dept.departmentName}
                                    </div>
                                  </td>
                                  <td colSpan={6} />
                                  <td colSpan={6} className="p-1.5 text-right whitespace-nowrap">
                                    <span className="text-xs font-semibold text-gray-700 mr-5">
                                      Total Payable Amt : ₹{Number(dept.totalPayableAmt).toLocaleString()}
                                    </span>
                                    <span className="text-xs font-semibold text-gray-700">
                                      Total Workers : {dept.totalWorkers}
                                    </span>
                                  </td>
                                </tr>
    
{!isDeptCollapsed(modeGroup.payoutMode, dept.departmentId) &&
  dept.records.map((record) => {
                                    const isEdited = editedRowIds.has(record.shift_id);
                                  const rowBg = isEdited
  ? 'bg-yellow-200'
  : record.lastdaypayment === true ? 'bg-[#FFFDED]' : 'bg-white';

                                    return (
                                      <tr key={record.id} className={`border-b h-12 cursor-pointer transition-colors duration-300 ${rowBg}`}>
                                        {/* Name */}
                                        <td className="p-1.5 text-left min-w-[120px]" onClick={() => handleRowClick(record.user_id)}>
                                          <div className="flex items-center gap-1.5">
                                          {record.OldPaymentEntry ? (
<div
  style={{
    position: "relative",
    width: 40,
    height: 40,
    flexShrink: 0,
  }}
>
  <img
    src={record.workerProfilePhoto || profile}
    alt="Profile"
    style={{
      width: 40,
      height: 40,
      borderRadius: "50%",
      objectFit: "cover",
      border: "2.5px solid red",
    }}
  />

  <div
    style={{
      position: "absolute",
      bottom: -7,
      right: -7,
      width: 20,
      height: 20,
      borderRadius: "50%",
      background: "#fff",
      border: "1.5px solid #fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxSizing: "border-box",
    }}
  >
    <img
      src={leftarrow}
      alt="Arrow"
      style={{
        width: 16,
        height: 16,
        objectFit: "contain",
      }}
    />
  </div>
</div>
):record.isScheduled ? (
<div style={{ position: 'relative', width: 40, height: 40, flexShrink: 0 }}>
    <img src={record.workerProfilePhoto || profile} alt="Profile"
      style={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover', border: '2.5px solid #22c55e' }} />
<div
  style={{
    position: "absolute",
    bottom: -7,
    right: -7,
    width: 20,
    height: 20,
    borderRadius: "50%",
    background: "#fff",
    border: "1.5px solid #fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
  }}
>
  <img
    src={calenderlogo}
    alt="Calendar"
    style={{
      width: 16,
      height: 16,
      objectFit: "contain",
      filter:
        "invert(48%) sepia(79%) saturate(500%) hue-rotate(100deg) brightness(50%)",
    }}
  />
</div>
  </div>
) : record.isUpcoming ? (
<div
  style={{
    position: "relative",
    width: 40,
    height: 40,
    flexShrink: 0,
  }}
>
  <img
    src={record.workerProfilePhoto || profile}
    alt="Profile"
    style={{
      width: 40,
      height: 40,
      borderRadius: "50%",
      objectFit: "cover",
      border: "2.5px solid #eab308",
    }}
  />

  <div
    style={{
      position: "absolute",
      bottom: -7,
      right: -7,
      width: 20,
      height: 20,
      borderRadius: "50%",
      background: "#fff",
      border: "1.5px solid #fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxSizing: "border-box",
    }}
  >
    <img
      src={calenderlogo}
      alt="Calendar"
      style={{
        width: 16,
        height: 16,
        objectFit: "contain",
        filter:
          "invert(77%) sepia(89%) saturate(1000%) hue-rotate(355deg) brightness(50%) contrast(100%)",
      }}
    />
  </div>
</div>
) :(
  <img src={record.workerProfilePhoto || profile} alt="Profile"
    className="w-10 h-10 rounded-full object-cover border border-gray-300 flex-shrink-0" />
)}
<div className="relative group inline-block">
  <div className="font-medium text-xs">{record.workerName}</div>
  <div className="text-gray-500" style={{ fontSize: 10 }}>
    {record.workerCode}
  </div>

  {/* Phone number shown above on hover */}
  <div className="absolute left-0 bottom-full mb-1 hidden group-hover:block bg-gray-800 text-white text-xs px-2 py-1 rounded shadow-lg whitespace-nowrap z-10">
    {record.workerPhone}
  </div>
</div>
                                          </div>
                                        </td>

                                        {/* Entry */}
                                        <td className="p-1.5 text-center">
                                          <div className="flex items-center justify-center gap-1">
                                            <div className="flex flex-col items-center">
                                              <div className="font-medium text-xs">{FormatDate(record.entry_date)}</div>
                                              <span className="text-gray-600 text-[10px]">{FormatTime(record.entry_date)}</span>
                                            </div>
                                            {editable && (record.payment_status === "payoutGenerated" || record.payment_status === "pending") && (
                                              <Edit className="h-3 w-3 text-black cursor-pointer hover:text-gray-700 flex-shrink-0"
                                                onClick={(e) => handleEntryClick(record, e)} title="Modify Entry Time" />
                                            )}
                                          </div>
                                        </td>

                                        {/* Exit */}
                                        <td className="p-1.5 text-center">
                                          <div className="flex items-center justify-center gap-1">
                                            <div className="flex flex-col items-center">
                                              <div className="font-medium text-xs">{FormatDate(record.exit_date)}</div>
                                              <span className="text-gray-600 text-[10px]">{FormatTime(record.exit_date)}</span>
                                            </div>
                                            {editable && (record.payment_status === "payoutGenerated" || record.payment_status === "pending")  && (
                                              <Edit className="h-3 w-3 text-black cursor-pointer hover:text-gray-700 flex-shrink-0"
                                                onClick={(e) => handleExitClick(record, e)} title="Modify Exit Time" />
                                            )}
                                          </div>
                                        </td>

                                        <td className="p-1.5 text-center text-xs font-medium">{record.working_hours}</td>
                                        <td className="p-1.5 text-center whitespace-nowrap"><span className="text-gray-800 font-medium text-xs">₹{dept.HourlyRate}</span></td>
                                        <td className="p-1.5 text-center whitespace-nowrap"><span className="font-medium text-xs">₹{record.gross_amount}</span></td>
                                        <td className="p-1.5 text-center whitespace-nowrap"><span className="font-medium text-xs text-red-500">-₹{record.food_taken}</span></td>
                                        <td className="p-1.5 text-center whitespace-nowrap"><span className="font-medium text-xs text-red-500">-₹{record.bus_entry}</span></td>
                                        <td className="p-1.5 text-center whitespace-nowrap"><span className="font-medium text-xs text-red-500">-₹{record.bus_exit}</span></td>
                                        <td className="p-1.5 text-center whitespace-nowrap"><span className="font-medium text-xs text-red-500">-₹{record.taken_apron}</span></td>
                                        <td className="p-1.5 text-center whitespace-nowrap"><span className="font-medium text-xs text-red-500">-₹{record.additional_deductions}</span></td>
                                        <td className="p-1.5 text-center whitespace-nowrap"><span className="font-medium text-xs text-green-500">+₹{record.bonus_amount}</span></td>

                                {/* Payout */}
<td className="p-1.5 text-center whitespace-nowrap">
  <div className="flex items-center justify-center gap-1 relative">
    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
      record.payment_status === "success" ? "bg-green-100 text-green-600"
      : record.payment_status === "failed"  ? "bg-red-100 text-red-600"
      : "text-blue-600"
    }`}>
      ₹{record.net_amount}
    </span>

    {editable && hasPayoutApproval && (
      <Edit className="h-3 w-3 text-black cursor-pointer hover:text-gray-700 flex-shrink-0"
        title="Modify Payment Amount"
        onClick={(e) => handlePaymentEditClick(record, e)} />
    )}

    {/* Accessories + Apron trigger */}
{/* Accessories trigger — only show if accessories array has items */}
{record.accessories && record.accessories.length > 0 && (
  <div
    className="relative tooltip-trigger flex-shrink-0"
    onMouseEnter={(e) => showAccessoryTooltip(e, record)}
    onMouseLeave={hideAccessoryTooltip}
    onClick={(e) => { e.stopPropagation(); showAccessoryTooltip(e, record); }}
  >
    <Package className="h-3 w-3 text-gray-500 hover:text-gray-700 cursor-pointer" />
  </div>
)}

    {/* Accessories + Apron tooltip */}
    {accessoryTooltip.visible &&
      accessoryTooltip.content &&
      accessoryTooltip.recordId === record.id && (
        <div
          className="fixed z-[9999] p-3 text-xs bg-white rounded-lg border border-gray-200 max-w-[220px]"
          style={{
            left: accessoryTooltip.position.x,
            top: accessoryTooltip.position.y,
            transform: "translate(-50%, -100%)",
          }}
        >
          <div className="space-y-1.5">
            {accessoryTooltip.content.accessories.map((acc) => (
              <div key={acc.accessoryId} className="flex items-center gap-2">
                <img
                  src={acc.logo}
                  alt={acc.name}
                  className="h-4 w-4 rounded-full"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = "/fallback-accessory-icon.png";
                  }}
                />
                <span className="text-gray-800">{acc.name}</span>
              </div>
            ))}
<div className="pt-1 border-t border-gray-100 font-medium text-gray-900">
  {record.taken_apron == 0
    ? `Total Refund Amount: ₹${record.bonus_amount ?? 0}`
    : `Total Deduction: ₹${record.taken_apron}`}
</div>
          </div>
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-white"></div>
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-200 mt-[-1px]"></div>
        </div>
      )}
  </div>
</td>
                              </tr>
                   );
                                      })}
                                </React.Fragment>
                              ))
                            )
                          )}
                      </React.Fragment>
                    ))
                  )}
                </tbody>
              </table>


              {/* ── Action Buttons ── */}
              {editable && hasAnyRecords && (
                <div className="mt-3 mb-2 flex justify-end flex-shrink-0">
                  {!isSuperadmin ? (
                    hasEdits || filestatus === "file_to_be_generated" || filestatus === "file_to_be_generated_by_approver" ? 
                    (
                      <button
                        onClick={() => openConfirm('regenerate')}
                        className="px-4 py-1.5 bg-amber-500 text-white text-sm rounded-md hover:bg-amber-600 flex items-center justify-center gap-2"
                      >
                        <RefreshCw className="h-3.5 w-3.5" />
                        Regenerate
                      </button>
                    ) :
                     isadmin ? (
                      hasPayoutGen && (filestatus === "file_generated" || filestatus === "file_updated" || filestatus === "rejected_by_admin") ? (
                        <button
                          onClick={() => openConfirm('sendToApprover')}
                          disabled={loading}
                          className="px-4 py-1.5 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 flex items-center justify-center gap-2"
                        >
                          Send To Payout Approver
                        </button>
                      ) : (
                        <div className="flex gap-4">
                          <button
                            onClick={() => openConfirm('sendBack')}
                            className="px-4 py-1.5 text-red-600 text-sm border font-semibold border-red-500 rounded-md flex items-center justify-center gap-1"
                          >
                            Send back to Payout Generator
                          </button>
                          <button
                            onClick={() => openConfirm('sendForAccounts')}
                            disabled={loading}
                            className="px-4 py-1.5 bg-green-600 text-white text-sm rounded-md hover:bg-green-700 flex items-center justify-center gap-1"
                          >
                            Send for accounts approval
                          </button>
                        </div>
                      )
                    ) : (
                      <button
                        onClick={() => openConfirm('sendToApprover')}
                        disabled={loading}
                        className="px-4 py-1.5 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 flex items-center justify-center gap-2"
                      >
                        Send To Payout Approver
                      </button>
                    )
                  ) : (
                    <div className="flex gap-4">
                      <button
                        onClick={() => openConfirm('reject')}
                        className="px-4 py-1.5 text-red-600 text-sm border font-semibold border-red-500 rounded-md flex items-center justify-center gap-1"
                      >
                        ✕ Reject
                      </button>
                      <button
                        onClick={() => openConfirm('approve')}
                        className="px-4 py-1.5 bg-green-600 text-white text-sm rounded-md hover:bg-green-700 flex items-center justify-center gap-1"
                      >
                        Approve
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>

        {/* ── Entry / Exit / Payment modals ── */}
        <HandleEntry
          showEntryModal={showEntryModal}
          hasPayoutGen={hasPayoutGen}
          hasPayoutApproval={hasPayoutApproval}
          selectedStatus={selectedStatus}
          setShowEntryModal={setShowEntryModal}
          selectedRecord={selectedRecord}
          selectedCompany={null}
          currentPage={1}
fetchAttendanceData={() => handleChildDataUpdate(selectedRecord?._shiftId)}
showentrymarkdays={showentrymarkdays}
setshowentrymarkdays={setshowentrymarkdays}
        />
        <HandleExit
          showExitModal={showExitModal}
          hasPayoutGen={hasPayoutGen}
          hasPayoutApproval={hasPayoutApproval}
           selectedStatus={selectedStatus}
          setShowExitModal={setShowExitModal}
          selectedRecord={selectedRecord}
          selectedCompany={null}
          isUTVMember={isUTVMember}
          currentPage={1}
 fetchAttendanceData={() => handleChildDataUpdate(selectedRecord?._shiftId)}

        />
        <HandlePayment
  paymentEditModal={paymentEditModal}
  hasPayoutGen={hasPayoutGen}
  hasPayoutApproval={hasPayoutApproval}
  selectedStatus={selectedStatus}
  setPaymentEditModal={setPaymentEditModal}
  showConfirmationModal={showConfirmationModal}
  setShowConfirmationModal={setShowConfirmationModal}
  selectedAttendanceId={selectedAttendanceId}
  setSelectedAttendanceId={setSelectedAttendanceId}
  retryingPayments={retryingPayments}
  setRetryingPayments={setRetryingPayments}
  currentPage={1}
  fetchAttendanceData={() => handleChildDataUpdate(paymentEditModal.record?._shiftId)}
  setAttendanceData={() => {}}
/>
      </div>
}

      {/*  Confirmation Modals  */}
      <ConfirmModal
        isOpen={activeConfirm === 'regenerate'}
        onClose={closeConfirm}
        loading={loading}
        icon={<RegenerateIcon />}
        iconBg="bg-amber-50"
        title="Regenerate Payout File?"
        description="This will regenerate the payout file. Any unsaved changes may be overwritten."
        confirmLabel="Yes, Regenerate"
        confirmClass="bg-amber-500 hover:bg-amber-600"
        onConfirm={() => { closeConfirm(); fetchlistingdata(); }}
      />
      <ConfirmModal
        isOpen={activeConfirm === 'sendToApprover'}
        onClose={closeConfirm}
        loading={loading}
        icon={<ApproveIcon />}
        iconBg="bg-blue-50"
        title="Send to Payout Approver?"
        description="The payout file will be submitted to the payout approver for review."
        confirmLabel="Yes, Send"
        confirmClass="bg-blue-600 hover:bg-blue-700"
        onConfirm={() => { closeConfirm(); handleSendForadminApproval(); }}
      />
      <ConfirmModal
        isOpen={activeConfirm === 'sendBack'}
        onClose={closeConfirm}
        loading={loading}
        icon={<RejectIcon />}
        iconBg="bg-red-50"
        title="Send Back to Payout Generator?"
        description="The payout file will be returned for revision. You'll be asked to add a reason."
        confirmLabel="Continue"
        confirmClass="bg-red-500 hover:bg-red-600"
        onConfirm={() => { closeConfirm(); setShowRemarksModal(true); }}
      />
      <ConfirmModal
        isOpen={activeConfirm === 'sendForAccounts'}
        onClose={closeConfirm}
        loading={loading}
        icon={<ApproveIcon />}
        iconBg="bg-green-50"
        title="Send for Accounts Approval?"
        description="The payout file will be forwarded to the accounts team for final approval."
        confirmLabel="Yes, Send"
        confirmClass="bg-green-600 hover:bg-green-700"
        onConfirm={() => { closeConfirm(); handleSendForaccountApproval(true); }}
      />
      <ConfirmModal
        isOpen={activeConfirm === 'approve'}
        onClose={closeConfirm}
        loading={loading}
        icon={<ApproveIcon />}
        iconBg="bg-green-50"
        title="Approve Payout File?"
        description="Are you sure you want to approve this payout file? This action cannot be undone."
        confirmLabel="Yes, Approve"
        confirmClass="bg-green-600 hover:bg-green-700"
        onConfirm={() => { closeConfirm(); /* approve handler */ }}
      />
      <ConfirmModal
        isOpen={activeConfirm === 'reject'}
        onClose={closeConfirm}
        loading={loading}
        icon={<RejectIcon />}
        iconBg="bg-red-50"
        title="Reject Payout File?"
        description="Are you sure you want to reject this payout file? The generator will be notified."
        confirmLabel="Yes, Reject"
        confirmClass="bg-red-500 hover:bg-red-600"
        onConfirm={() => { closeConfirm(); /* reject handler */ }}
      />

      {/*  Result Modals  */}
      {showSuccessModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-xl shadow-xl p-8 flex flex-col items-center gap-4 min-w-[300px]">
            <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
              <svg className="w-9 h-9 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-lg font-bold text-gray-800">Regenerated Successfully!</h2>
            <p className="text-sm text-gray-500 text-center">The payout file has been regenerated. The page will now refresh.</p>
            <button onClick={() => { setShowSuccessModal(false); window.location.reload(); }}
              className="px-6 py-2 bg-green-600 text-white text-sm font-semibold rounded-md hover:bg-green-700 transition-colors">
              OK
            </button>
          </div>
        </div>
      )}

      {showApprovalSuccessModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-xl shadow-xl p-8 flex flex-col items-center gap-4 min-w-[300px]">
            <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center">
              <svg className="w-9 h-9 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-lg font-bold text-gray-800">Sent for Approval!</h2>
            <p className="text-sm text-gray-500 text-center">The payout file has been successfully submitted for approval.</p>
            <button onClick={() => { setShowApprovalSuccessModal(false); window.location.reload(); }}
              className="px-6 py-2 bg-blue-600 text-white text-sm font-semibold rounded-md hover:bg-blue-700 transition-colors">
              OK
            </button>
          </div>
        </div>
      )}

      {showapprovalrejectmodal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-xl shadow-xl p-8 flex flex-col items-center gap-4 min-w-[300px]">
            <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
              <svg className="w-9 h-9 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h2 className="text-lg font-bold text-gray-800">Rejected</h2>
            <p className="text-sm text-gray-500 text-center">The payout file has been rejected.</p>
            <button onClick={() => { setshowapprovalrejectmodal(false); window.location.reload(); }}
              className="px-6 py-2 bg-red-600 text-white text-sm font-semibold rounded-md hover:bg-red-700 transition-colors">
              OK
            </button>
          </div>
        </div>
      )}

      {/*  Remarks Modal  */}
      {showRemarksModal && (
        <div className="fixed inset-0 z-[300] flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-xl shadow-xl w-[360px] p-6 flex flex-col gap-4">
            <div className="flex items-center justify-between">
              <h2 className="text-sm font-bold text-gray-800">Add Remarks</h2>
              <button onClick={() => { setShowRemarksModal(false); setRemarks(""); }} className="text-gray-400 hover:text-gray-600">
                <X className="h-4 w-4" />
              </button>
            </div>
            <p className="text-xs text-gray-500 -mt-2">Please provide a reason for sending back this payout file.</p>
            <textarea
              rows={4}
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              placeholder="Enter remarks..."
              className="w-full border border-gray-300 rounded-md p-2.5 text-xs resize-none focus:outline-none focus:ring-1 focus:ring-red-400 focus:border-red-400"
            />
            <div className="flex gap-3">
              <button
                onClick={() => { setShowRemarksModal(false); setRemarks(""); }}
                className="flex-1 py-1.5 text-xs border border-gray-300 rounded-md text-gray-600 hover:bg-gray-50 font-medium transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleRemarksSubmit}
                disabled={!remarks.trim() || loading}
                className="flex-1 py-1.5 text-xs bg-red-600 text-white rounded-md hover:bg-red-700 disabled:bg-red-300 disabled:cursor-not-allowed font-medium transition-colors"
              >
                Submit & Send Back
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Payoutfile;